export default "__VITE_ASSET__DsbJUW3x__"